import {
  BagFeaturedUpsellCard,
  BagFeaturedUpsellConfetti,
  BagFeaturedUpsellDialog,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const BagFeaturedUpsell = {
  Dialog: BagFeaturedUpsellDialog,
  Card: BagFeaturedUpsellCard,
  Confetti: BagFeaturedUpsellConfetti,
};
